const brands = [
    { img_url: "/trustedby/beta.svg" },
    { img_url: "/trustedby/incus.svg" },
    { img_url: "/trustedby/universe.svg" },
    { img_url: "/trustedby/bluespec.svg" },
    { img_url: "/trustedby/unclecharlie.svg" },
    { img_url: "/trustedby/thecontainer.svg" },
  ];
  
  function TrustedBy() {
    return (
      <div className="relative max-w-[1200px] mx-auto">
        <div className="border border-gray-200 p-12 py-20">
          <p className="text-center text-xl text-[#697586] mb-8 geist-mono">
            Trusted by 5000+ marketing professionals
          </p>
          
          <div className="flex justify-between space-x-4  items-center lg:px-16">
            {brands.map((item, index) => (
              <div key={index} className="flex items-center h-8">
                <img 
                  src={item.img_url} 
                  alt="brand" 
                  className=""
                />
              </div>
            ))}
          </div>
        </div>
  
        <div className="absolute left-1 -translate-x-1/2 -top-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>
  
        <div className="absolute -top-px -right-px w-4 h-4 border-t-2 border-r-2 border-black"></div>

        <div className="absolute -bottom-px -left-px w-4 h-4 border-b-2 border-l-2 border-black"></div>
        <div className="absolute right-1 -translate-x-1 -bottom-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>
      </div>
    );
  }
  
  export default TrustedBy;